import { getDDALine, getBresenhamLine, getMidpointCircle } from './algorithms';

export const executeAlgorithm = async (algorithm, params) => {
  try {
    let points;
    
    switch (algorithm) {
      case 'dda':
        points = getDDALine(params.x0, params.y0, params.x1, params.y1);
        break;
      case 'bresenham':
        points = getBresenhamLine(params.x0, params.y0, params.x1, params.y1);
        break;
      case 'midpoint-circle':
        points = getMidpointCircle(params.centerX, params.centerY, params.radius);
        break;
      default:
        throw new Error('Unknown algorithm');
    }
    
    return points;
  } catch (error) {
    console.error('Error executing algorithm:', error);
    throw error;
  }
};
